// Filter controls shared by pages: radio "segmented" groups.

/** Checks the radio with `value` inside `group`. */
export function setRadio(group: HTMLElement, name: string, value: string): void {
  for (const input of group.querySelectorAll<HTMLInputElement>(`input[type="radio"][name="${name}"]`)) {
    input.checked = input.value === value;
  }
}

/** Calls `onChange` with the newly checked value of radio group `name`. */
export function onRadio(group: HTMLElement, name: string, onChange: (value: string) => void): void {
  group.addEventListener('change', (ev) => {
    const t = ev.target;
    if (t instanceof HTMLInputElement && t.type === 'radio' && t.name === name && t.checked) onChange(t.value);
  });
}
